<template>
	<div id="appraisalinvoices-index"
		 class="app-home ui-styles"
		 :class="theme">

		<template class="view_container">

			<div class="loading_view" v-if="master_loading">
				<div class="view_spinner_container">
					<span style="color: rgb(0, 79, 146); margin: 0 auto;">
					<icon name="spinner" scale="4"
						  color="rgb(0, 79, 146)" spin></icon></span><br>
					<span>{{ $t('Loading')}}...</span>
				</div>
			</div>

			<div class="master_view">
				<side-nav-bar :invoicesOpen="invoicesOpen"></side-nav-bar>
				<div class="app-container">

					<bar>
					</bar>
					<h1>{{ $t('Appraisal_invoices_index') }}</h1>
					<!--
					<div>
						<div @click.prevent="onCreateNewAppraisalInvoice" style="width: fit-content; margin-left: auto">
							<icon-button icon="plus-circle" :text="new_appraisalinvoice_button_text"
										 icon_color="black"
										 text_color="black" border_color="lightgray"></icon-button>
						</div>
					</div>
					-->
					<div class="grid-row" layout="row top-stretch">
						<div class="grid-cell" layout="row">
							<input type="text" :placeholder="filter_placeholder" self="size-x1"
								   v-model="appraisalinvoice_table.filter"
								   data-intro="You can filter the data in a datatable by typing in any of the filter fields"
								   data-step="9" data-position="top">
						</div>
					</div>
					<div class="grid-row" layout="row top-stretch">
						<div class="grid-cell">
							<paginator :source="appraisalinvoices_to_array(appraisalinvoices)" :page-size="10"
									   :filter="appraisalinvoice_table.filter"
									   data-intro="Use the paginator to page data for easier viewing" data-step="10"
									   data-position="top">
								<template scope="page">
									<datatable id="data-table-main"
											   :source="page.data"
											   :filterable="false"
											   :striped="appraisalinvoice_table.striped"
											   :editable="appraisalinvoice_table.editable"
											   :line-numbers="appraisalinvoice_table.lineNumbers">
										<datatable-column
												v-for="column in appraisalinvoice_table.columns"
												:id="column.id"
												:label="column.label"
												:width="column.width"
												:sortable="column.sortable"
												:groupable="column.groupable"
												:formatter="column.formatter">
										</datatable-column>
										<datatable-column id="actions" label="Actions" :sortable="false"
														  :groupable="false"></datatable-column>
										<!--<template slot="sel" scope="cell">
											<div class="checkable-column">
												<checkbox :id="cell.row.id" :value="cell.row" v-model="appraisalinvoice_table.selected"></checkbox>
											</div>
										</template>-->
										<template slot="number" scope="cell">
											<span class="navspan"
												  @click.prevent="goToInvoice(cell.row['id'], cell.row['file_id'])">{{ cell.row['number']
												}}</span>
										</template>
										<template slot="actions" scope="cell">
											<a @click="editAppraisalInvoice(cell.row)"
											   style="margin-right: 2rem; cursor: pointer;">
												<icon name="pencil" scale="1" color="gray"></icon>
											</a>
											<a @click="deleteAppraisalInvoice(cell.row)" style="cursor: pointer;">
												<icon name="trash-o" scale="1" color="gray"></icon>
											</a>
										</template>
									</datatable>
								</template>
							</paginator>
						</div>
					</div>
					<!--
					<bar>
					</bar>
-->

				</div>
			</div>

		</template>
	</div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex'
    import Vue from 'vue'
    import _ from 'lodash'
    import moment from 'moment'
    import router from '../../../router'
    import { localStorageMixin } from '../../../mixins'
    import Spinner from '../../../components/Spinner.vue'
    import Search from '../../../components/ContactsSearch/Index.vue'
    import Editor from '../../../components/Editor/Index.vue'
    import Bar from '../../../components/Bar/Index.vue'
    import IconButton from '../../../components/IconButton/Index.vue'
    import SideNavBar from '../../../components/SideNavBar/Index.vue'

    import Datatable from '../../../components/Datatable/datatable.vue'
    import DatatableColumn from '../../../components/Datatable/datatable-column.vue'
    import aggregators from '../../../aggregators/aggregators.js'
    import formatters from '../../../formatters/formatters.js'
    import Checkbox from '../../../components/Toggles/checkbox.vue'
    import Paginator from '../../../components/Paginator/paginator.vue'

    export default {
        name: 'appraisalinvoices-index',

        mixins: [localStorageMixin],

        data: () => ({
            master_loading: true,
            invoicesOpen: true,
            filter_placeholder: Vue.i18n.translate('Type_here_to_filter_paginated_data'),
            new_appraisalinvoice_button_text: Vue.i18n.translate('Add_appraisal_invoice'),
            appraisalinvoice_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'fiscal_number',
                        label: Vue.i18n.translate('Invoice_fiscal_number'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'full_number',
                        label: Vue.i18n.translate('Version'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'date_modified',
                        label: Vue.i18n.translate('Last_modified'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return moment(value).format('DD/MM/YYYY HH:mm:ss')
                        }
                    }

                ],
                selected: []
            }

        }),

        created () {
            this.FETCH_APPRAISALINVOICES()
                .then(() => {
                    this.master_loading = false
                })
        },

        components: {
            Bar,
            Checkbox,
            Datatable,
            DatatableColumn,
            IconButton,
            Paginator,
            Spinner,
            SideNavBar
        },

        computed: {
            ...mapGetters([
                'appraisalinvoices',
                'theme',
            ])
            /*
			 selectAll: {
			 get: function () {
			 return this.appraisalinvoice_table.selected.length === this.appraisalinvoice_table.rows.length
			 },
			 set: function (value) {
			 this.appraisalinvoice_table.selected = value ? this.appraisalinvoice_table.rows : []
			 }
			 }
			 */
        },

        methods: {
            ...mapActions([
                'CREATE_NEW_APPRAISALINVOICE',
                'DELETE_APPRAISALINVOICE',
                'EDIT_APPRAISALINVOICE',
                'FETCH_APPRAISALINVOICES',
                'SET_APPRAISALINVOICE',
				'SET_APPRAISALFILE'
            ]),
            onCreateNewAppraisalInvoice: function () {

                this.master_loading = true

                const appraisalinvoices_size = _.size(this.appraisalinvoices)

                let new_invoicenumber = 1

                if (appraisalinvoices_size > 0) {

                    const invoicenumbers = _.reverse(_.map(this.appraisalinvoices, 'number'))
                    new_invoicenumber = invoicenumbers[0] + 1
                    console.log('map invoicenumbers: ')
                    console.log(invoicenumbers)

                }
                this.CREATE_NEW_APPRAISALINVOICE({
                    path: 'appraisalinvoices',
                    number: new_invoicenumber,
                    size: appraisalinvoices_size
                }).then((res) => {
                    this.$router.push({name: 'appraisalinvoice-editor'})
                })
            },
            appraisalinvoices_to_array: function (object) {
                return _.values(object)
            },
            editAppraisalInvoice: function (entity) {
                console.log('edit...')
                this.SET_APPRAISALFILE({path: 'appraisalfiles' + '/' + entity.file_id}).then((res) => {
                    this.SET_APPRAISALINVOICE({path: 'appraisalinvoices' + '/' + entity.id}).then((res) => {
                        this.$router.push({
                            name: 'appraisalinvoice-editor',
                            query: {id: entity.id, file_id: entity.file_id}
                        })

                    })
                })
            },
            deleteAppraisalInvoice: function (entity) {

                const result = window.confirm(Vue.i18n.translate('You_are_about_to_delete') + ' ' + Vue.i18n.translate('invoice') + ' "' + entity.number + '". ' + Vue.i18n.translate('Continue_q'))

                if (result) {

                    this.DELETE_APPRAISALINVOICE({
                        path: 'appraisalinvoices' + '/' + entity.id,
                        key: entity.id,
                        appraisalreports: entity.appraisalreports
                    }).then((res) => {
                        //
                        this.master_loading = true
                        this.FETCH_APPRAISALINVOICES()
                            .then(() => {
                                this.master_loading = false
                            })
                    })

                }

            },
            goToInvoice (key, file_id) {
                this.SET_APPRAISALFILE({path: 'appraisalfiles' + '/' + file_id}).then((res) => {
                    this.SET_APPRAISALINVOICE({path: 'appraisalinvoices' + '/' + key}).then((res) => {
                        this.$router.push({name: 'appraisalinvoice-editor', query: {id: key, file_id: file_id}})

                    })
                })
            }
        },
        head: {
            title: {
                inner: 'Appraisal-Invoices Index'
            }
        }

    }
</script>



// WEBPACK FOOTER //
// AppraisalInvoicesIndex.vue?3564fcff